import { calculateGradientColor } from '~/_shared/utils/colors/colors.helpers';
import type { HexColor } from '~/_shared/utils/colors/colors.types';
import { isBoundaryTerritorySpecialOrCustom } from '~/boundary/settings/boundarySettings.helpers';
import type {
  BoundaryTerritory, BoundaryTerritoryGroupStyle,
} from '~/store/boundaryTerritoryGroups/boundaryTerritoryGroups.state';

export const recalculateBoundaryTerritoryColors = (
  boundaryTerritories: ReadonlyArray<BoundaryTerritory>,
  gradientColors: BoundaryTerritoryGroupStyle['gradientColors'],
): ReadonlyArray<BoundaryTerritory> => {
  const numericalTerritories = boundaryTerritories.filter(bt => !isBoundaryTerritorySpecialOrCustom(bt));
  const specialTerritories = boundaryTerritories.filter(bt => isBoundaryTerritorySpecialOrCustom(bt));

  const { minimal, low, medium, high } = gradientColors;
  const colorsToUse: NonEmptyArray<HexColor> = [minimal.color, low.color, medium.color, high.color];

  const newNumericalTerritories = numericalTerritories.map((bt, index) => ({
    ...bt,
    style: {
      ...bt.style,
      color: calculateGradientColor({
        position: index,
        totalCount: numericalTerritories.length,
        colors: colorsToUse,
      }),
      opacity: 50,
    },
  }));

  return newNumericalTerritories.concat(specialTerritories);
};
